
import React, { useEffect, useState } from "react";
import WorkspaceService from "services/workspace-service";
import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Avatar from "@mui/material/Avatar";
import AvatarGroup from "@mui/material/AvatarGroup";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import SocialSnapshot from "./components/SocialSnapshot";
import ProfileService from "services/profile-service";
import SnapshotService from "services/snapshot-service";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import EditIcon from "@mui/icons-material/Edit";
import DownloadIcon from "@mui/icons-material/Download";
import EmailIcon from "@mui/icons-material/Email"; // [NEW]
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import AssessmentIcon from "@mui/icons-material/Assessment";
import { styled } from "@mui/material/styles";
import {
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Menu,
  MenuItem,
  AppBar, // [NEW] Added for sliding tabs
} from "@mui/material";
import { useLocation } from "react-router-dom";
import Grow from "@mui/material/Grow";
import { format, addDays, addWeeks, addMonths, subDays, startOfMonth, endOfMonth, subMonths } from "date-fns";
import SocialStudioIntroStep from "layouts/tutorial/steps/SocialStudioIntroStep";
import { AuthContext } from "context";
import AuthService from "services/auth-service";
import ReportGenService from "services/reportgen-service"; // [NEW] Import ReportGenService
import SocialReport from "./components/SocialReport";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import SocialStudioGuidanceStep from "layouts/guidance/steps/SocialStudioGuidanceStep";
import UpgradePopup from "layouts/components/Upgrade";
import MDSnackbar from "components/MDSnackbar"; // [NEW] Import MDSnackbar
import { usePermissions } from "context"; // [FIXED] Use usePermissions
import LiveDemoRestriction from "layouts/components/Upgrade/liveDemo"; // [NEW] Live Demo Popup

function SocialStudio() {
  const [showSnapshots, setShowSnapshots] = useState(false);
  const [workspaceSnapshots, setWorkspaceSnapshots] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // [NEW] Notification State
  const [notificationSB, setNotificationSB] = useState({
    open: false,
    color: "info",
    icon: "notifications",
    title: "Social Studio",
    content: "",
  });

  // [NEW] Store workspace profile metadata (ID -> own status) to fix edit report issues
  const [workspaceProfileMeta, setWorkspaceProfileMeta] = useState({});

  const openNotificationSB = (color, icon, title, content) => {
    setNotificationSB({
      open: true,
      color,
      icon,
      title,
      content,
    });
  };

  const closeNotificationSB = () => setNotificationSB({ ...notificationSB, open: false });
  const [editSnapshotData, setEditSnapshotData] = useState(null);
  const [oauthIntent, setOauthIntent] = useState(null);
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [snapshotToDelete, setSnapshotToDelete] = useState(null);
  const [deleting, setDeleting] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeSnapshot, setActiveSnapshot] = useState(null);
  const [menuIntent, setMenuIntent] = useState("download"); // [NEW] 'download' | 'email'
  const [activeTab, setActiveTab] = useState(0); // [NEW] 0 = Snapshots, 1 = Reports
  const [workspaceReports, setWorkspaceReports] = useState([]); // [NEW]
  const [showReports, setShowReports] = useState(false); // [NEW] To toggle create/edit view
  const [editReportData, setEditReportData] = useState(null); // [NEW]
  const [reportToDelete, setReportToDelete] = useState(null); // [NEW]
  const [downloadingIds, setDownloadingIds] = useState(new Set());
  const [sendingIds, setSendingIds] = useState(new Set()); // [NEW]
  const [entitlements, setEntitlements] = useState(null);
  const [showReportUpgrade, setShowReportUpgrade] = useState(false); // [NEW]
  const [reportUpgradeType, setReportUpgradeType] = useState("feature"); // [NEW] feature | usage
  const location = useLocation();

  // Tutorial State
  const { isAuthenticated } = React.useContext(AuthContext);
  const [showTutorial, setShowTutorial] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);

  // Demo State
  const isLiveDemo = sessionStorage.getItem('demo_role_cache') === "demo_viewer";
  const [demoCompleted, setDemoCompleted] = useState(false);
  const [showLiveDemoPopup, setShowLiveDemoPopup] = useState(false); // [NEW] Popup state

  const [showRBAC, setShowRBAC] = useState(false);
  const [rbacFeature, setRbacFeature] = useState("");
  const [rbacRole, setRbacRole] = useState("");

  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false); // [NEW]
  const [errorDialogTitle, setErrorDialogTitle] = useState("Alert"); // [NEW]
  const [errorDialogMessage, setErrorDialogMessage] = useState(""); // [NEW]

  const { hasPermission, requiredRoles, refreshPermissions } = usePermissions();

  const openErrorDialog = (title, message) => {
    setErrorDialogTitle(title);
    setErrorDialogMessage(message);
    setIsErrorDialogOpen(true);
  };

  useEffect(() => {
    const isCompleted = localStorage.getItem("social_studio_demo_completed") === "true";
    if (isCompleted) setDemoCompleted(true);
  }, []);

  useEffect(() => {
    if (!isAuthenticated) return;

    const checkTutorial = async () => {
      try {
        const resp = await AuthService.getProfile();
        const userData = resp.data.attributes;
        setCurrentUser(userData);

        const completedSteps = userData.completed_tutorials || [];
        if (!completedSteps.includes("social_studio_intro")) {
          setShowTutorial(true);
        }
      } catch (error) {
        console.error("Failed to check tutorial status:", error);
      }
    };
    checkTutorial();
  }, [isAuthenticated]);

  // Reset view when clicking side nav (navigating to same route)
  useEffect(() => {
    // Check if we are at the root path without special intents
    if (location.pathname === "/social-studio") {
      // Only reset if we are not in the middle of an oauth callback flow
      // (oauthIntent is handled separately)
      if (!location.search) {
        setShowSnapshots(false);
        setEditSnapshotData(null);
      }
    }
  }, [location.pathname, location.search, location.state, location.key]);

  const handleCompleteTutorial = async () => {
    try {
      const currentCompleted = currentUser?.completed_tutorials || [];
      if (!currentCompleted.includes("social_studio_intro")) {
        const updatedTutorials = [...currentCompleted, "social_studio_intro"];
        await AuthService.updateProfile({
          data: { attributes: { completed_tutorials: updatedTutorials } }
        });
      }
      setShowTutorial(false);
    } catch (error) {
      console.error("Failed to complete tutorial:", error);
      setShowTutorial(false);
    }
  };

  const handleMenuOpen = (event, snapshot, intent = "download") => {
    setAnchorEl(event.currentTarget);
    setActiveSnapshot(snapshot);
    setMenuIntent(intent);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setActiveSnapshot(null);
    setMenuIntent("download");
  };

  const formatMonthLabel = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString("default", { month: "short", year: "numeric" });
  };

  const handleGenerateSnapshotFromRun = async (snapshot, run) => {
    handleMenuClose();

    if (!run?.range_start || !run?.range_end) {
      openErrorDialog("Snapshot Error", "Invalid snapshot run range.");
      return;
    }

    // 🌀 Add snapshot to active downloads
    setDownloadingIds((prev) => new Set(prev).add(snapshot._id));

    const snapshotInfo = {
      snapshotType: snapshot.snapshot_type,
      snapshotName: snapshot.snapshot_name,
      emails: snapshot.recipient_emails?.map((e) => e.trim()).filter(Boolean),
      primaryProfile: {
        profileId: snapshot.primary_profile?.profile_id,
        platform: snapshot.primary_profile?.platform,
      },
      secondaryProfiles: (snapshot.secondary_profiles || []).map((p) => ({
        profileId: p.profile_id,
        platform: p.platform,
      })),
      frequency: snapshot.frequency || "once",
      scheduleEnabled: snapshot.scheduleEnabled || false,
      rangeStart: run.range_start,
      rangeEnd: run.range_end,
      nextRunAt: snapshot.nextRunAt || null,
      branding_pack_id: snapshot.branding_pack_id || null, // [FIX] Include branding
      target_client: snapshot.target_client || null,       // [FIX] Include styling
    };

    try {
      console.log("🚀 Generating snapshot:", snapshotInfo.snapshotType);
      switch (snapshotInfo.snapshotType.toLowerCase()) {
        case "market":
          await SnapshotService.generateMarketSnapshot(snapshotInfo);
          break;
        case "brand":
          await SnapshotService.generateBrandSnapshot(snapshotInfo);
          break;
        case "content":
          await SnapshotService.generateContentSnapshot(snapshotInfo);
          break;
        case "campaign":
          await SnapshotService.generateCampaignSnapshot(snapshotInfo);
          break;
        default:
          openErrorDialog("Process Error", `Unknown snapshot type: ${snapshotInfo.snapshotType}`);
      }
    } catch (error) {
      console.error("❌ Error generating snapshot:", error);
      openErrorDialog("Generation Failed", "Failed to generate snapshot. Please try again.");
    } finally {
      // 🧹 Remove snapshot from active downloads
      setDownloadingIds((prev) => {
        const updated = new Set(prev);
        updated.delete(snapshot._id);
        return updated;
      });
    }
  };

  // [NEW] Handle Historical GCS Download
  const handleDownloadGCS = async (snapshotId, runIndex) => {
    try {
      setDownloadingIds((prev) => new Set(prev).add(snapshotId));
      const signedUrl = await SnapshotService.getSnapshotRunDownloadLink(snapshotId, runIndex);
      window.open(signedUrl, "_blank");
    } catch (error) {
      console.error("Failed to get download link:", error);
      openErrorDialog("Download Error", "Failed to fetch download link. Please try again.");
    } finally {
      setDownloadingIds((prev) => {
        const next = new Set(prev);
        next.delete(snapshotId);
        return next;
      });
      handleMenuClose();
    }
  };


  // ───────────────────────────────
  // Custom Tooltip Styling
  // ───────────────────────────────
  const CustomTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))({
    [`& .${tooltipClasses.tooltip}`]: {
      maxWidth: 400,
      textAlign: "left",
    },
  });

  const tooltipContent = (
    <div style={{ minWidth: "350px", textAlign: "left" }}>
      <Typography variant="body2" gutterBottom>
        <strong>How to Use Create Snapshot:</strong>
      </Typography>
      <Typography variant="caption" display="block" gutterBottom>
        - Start by selecting the type of snapshot. <br />
        - Based on the snapshot type choose primary profile. <br />
        - Choose one or more secondary profiles to compare against. <br />
        - Review your selection before generating the snapshot.
      </Typography>
      <Typography variant="body2" gutterBottom>
        <strong>Snapshot Setup Tips:</strong>
      </Typography>
      <Typography variant="caption" display="block" gutterBottom>
        - Give your snapshot a clear, recognisable name. <br />
        - Add one or more recipient emails to receive the report. <br />
        - Enable scheduling if you'd like to generate this snapshot monthly.
      </Typography>
      <Typography variant="body2" gutterBottom>
        <strong>Best Practices:</strong>
      </Typography>
      <Typography variant="caption" display="block">
        - Use verified and active profiles for best insights. <br />
        - Ensure your reporting range covers at least one month of activity. <br />
        - You can always revisit and regenerate snapshots later. <br />
      </Typography>
    </div>
  );

  // ───────────────────────────────
  // Fetch Workspace Snapshots
  // ───────────────────────────────
  const fetchWorkspaceSnapshots = async () => {
    try {
      setLoading(true);
      const data = await WorkspaceService.fetchWorkspaceSnapshots();

      const enrichedData = await Promise.all(
        data.map(async (snapshot) => {
          const primaryProfileList = snapshot.primary_profile
            ? Array.isArray(snapshot.primary_profile)
              ? snapshot.primary_profile
              : [snapshot.primary_profile]
            : [];

          const secondaryProfileList = snapshot.secondary_profiles
            ? Array.isArray(snapshot.secondary_profiles)
              ? snapshot.secondary_profiles
              : [snapshot.secondary_profiles]
            : [];

          const primaryGrouped = groupByPlatform(primaryProfileList);
          const secondaryGrouped = groupByPlatform(secondaryProfileList);

          const primaryResponses = await Promise.all(
            Object.entries(primaryGrouped).map(([platform, ids]) =>
              ProfileService.fetchProfile(platform, ids)
            )
          );

          const secondaryResponses = await Promise.all(
            Object.entries(secondaryGrouped).map(([platform, ids]) =>
              ProfileService.fetchProfile(platform, ids)
            )
          );

          const primaryProfile = primaryResponses.flat();
          const secondaryProfiles = secondaryResponses.flat();

          return {
            ...snapshot,
            primaryProfile,
            secondaryProfiles,
          };
        })
      );

      // Sort by the most recently updated/created date (newest first)
      enrichedData.sort((a, b) => {
        const dateA = new Date(a.updatedAt || a.updated_at || a.createdAt || a.created_at || 0);
        const dateB = new Date(b.updatedAt || b.updated_at || b.createdAt || b.created_at || 0);
        return dateB - dateA;
      });

      setWorkspaceSnapshots(enrichedData);
    } catch (err) {
      console.error("❌ Error fetching workspace snapshots:", err);
      setError("Failed to load snapshots.");
    } finally {
      setLoading(false);
    }
  };

  const groupByPlatform = (profiles) => {
    return profiles.reduce((acc, { platform, profile_id }) => {
      if (!acc[platform]) acc[platform] = [];
      acc[platform].push(profile_id);
      return acc;
    }, {});
  };

  useEffect(() => {
    async function fetchEntitlements() {
      try {
        const data = await WorkspaceService.fetchWorkspaceEntitlements();
        setEntitlements(data);
        // 🔥 Also sync the global AuthContext so that hasPermission() is up-to-date
        refreshPermissions();
      } catch (err) {
        console.error("Failed to fetch entitlements", err);
      }
    }
    fetchEntitlements();

    // ✅ Listen for workspace switches (soft refresh)
    const onProfileUpdated = () => fetchEntitlements();
    window.addEventListener("profile-updated", onProfileUpdated);
    return () => window.removeEventListener("profile-updated", onProfileUpdated);
  }, []);

  useEffect(() => {
    fetchWorkspaceSnapshots();

    // ✅ Listen for workspace switches (soft refresh)
    const onProfileUpdated = () => fetchWorkspaceSnapshots();
    window.addEventListener("profile-updated", onProfileUpdated);
    return () => window.removeEventListener("profile-updated", onProfileUpdated);
  }, []);

  // ───────────────────────────────
  // OAuth Intent Handling
  // ───────────────────────────────
  useEffect(() => {
    const intent = localStorage.getItem("postOAuthIntent");
    if (intent) {
      setShowSnapshots(true);
      setOauthIntent(intent);
    }
  }, []);

  // ───────────────────────────────
  // Handlers
  // ───────────────────────────────
  // [NEW] Robust Permission Check (Fallbacks to local entitlements if global is stale)
  const hasPerm = (permission) => {
    if (hasPermission(permission)) return true;
    // Fallback to local entitlements data if global state hasn't refreshed yet
    if (entitlements?.permissions?.includes(permission)) return true;
    return false;
  };

  const handleShowSnapshots = () => {
    if (!hasPerm("snapshots:manage")) {
      setRbacFeature("Creating Snapshots");
      setRbacRole(requiredRoles["snapshots:manage"] || "Manager");
      setShowRBAC(true);
      return;
    }
    setEditSnapshotData(null);
    setShowSnapshots(true);
  };

  const handleGoBack = () => {
    setShowSnapshots(false);
    fetchWorkspaceSnapshots();
  };

  // ───────────────────────────────
  // Fetch Workspace Reports
  // ───────────────────────────────
  const fetchWorkspaceReports = async () => {
    try {
      setLoading(true);
      const data = await WorkspaceService.fetchWorkspaceReports();
      setWorkspaceReports(data || []);
    } catch (err) {
      console.error("❌ Error fetching workspace reports:", err);
      // setError("Failed to load reports."); // Optional: show distinct error
    } finally {
      setLoading(false);
    }
  };

  // Switch tabs
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    if (newValue === 0) {
      fetchWorkspaceSnapshots();
    } else {
      fetchWorkspaceReports();
    }
  };

  // [NEW] Fetch User Profiles to build "Own" map
  useEffect(() => {
    async function loadProfileMeta() {
      try {
        const profiles = await WorkspaceService.fetchWorkspaceProfiles();
        const meta = {};
        profiles.forEach(p => {
          meta[p.id] = p.own === true;
        });
        setWorkspaceProfileMeta(meta);
      } catch (err) {
        console.error("Failed to load workspace profiles for meta:", err);
      }
    }
    loadProfileMeta();

    // ✅ Listen for workspace switches (soft refresh)
    const onProfileUpdated = () => loadProfileMeta();
    window.addEventListener("profile-updated", onProfileUpdated);
    return () => window.removeEventListener("profile-updated", onProfileUpdated);
  }, []);

  // ───────────────────────────────
  // Report Handlers
  // ───────────────────────────────
  // ───────────────────────────────
  const handleCreateReport = () => {
    // [NEW] Live Demo Restriction
    if (isLiveDemo) {
      setShowLiveDemoPopup(true);
      return;
    }

    // 🔒 1. CHECK ENTITLEMENT (Priority)
    const isLocked = entitlements?.features && !entitlements.features.includes("Report");
    if (isLocked) {
      setReportUpgradeType("feature");
      setShowReportUpgrade(true);
      return;
    }

    // 🔒 2. CHECK USAGE LIMIT
    const reportsUsed = entitlements?.usage?.active_reports || 0;
    const reportsLimit = entitlements?.limits?.reports || 0;
    if (Number(reportsUsed) >= Number(reportsLimit)) {
      setReportUpgradeType("usage");
      setShowReportUpgrade(true);
      return;
    }

    // [NEW] RBAC Check
    if (!hasPerm("reports:manage")) {
      setRbacFeature("Creating Reports");
      setRbacRole(requiredRoles["reports:manage"] || "Analyst");
      setShowRBAC(true);
      return;
    }

    setEditReportData(null);
    setShowReports(true);
  };

  const handleEditReport = (report) => {
    console.log("✏️ Editing Report:", report);

    // Transform report data to match stepper expectations
    setEditReportData({
      id: report._id,  // ← CRITICAL: Include ID for update operation
      report_name: report.report_name,  // ← Match ReportConfiguration field name
      profiles: (report.config?.selectedProfiles || []).map(p => ({
        id: p.id,
        platform: p.platform,
        name: p.name,
        profilePictureUrl: p.profilePictureUrl,
        own: workspaceProfileMeta[p.id] || false // [FIX] Re-hydrate 'own' flag from authoritative source
      })),
      category: report.config?.selectedCategories || [],
      visibleCharts: report.config?.visibleCharts || [],
      chartConfigs: report.config?.chartConfigs || {},
      period: report.config?.period || "last_30_days",
      frequency: report.frequency,
      scheduleEnabled: report.scheduleEnabled,
      recipient_emails: report.recipient_emails || [],  // ← Match ReportConfiguration field name
      config: report.config  // ← Pass entire config for ReportConfiguration
    });

    setShowReports(true);
  };

  const handleReportGoBack = () => {
    setShowReports(false);
    setEditReportData(null);
    fetchWorkspaceReports();
  };

  const handleDeleteReportClick = (report) => {
    setReportToDelete(report);
    setIsConfirmDialogOpen(true);
  };

  const handleConfirmReportDelete = async () => {
    if (!reportToDelete) return;
    try {
      setDeleting(true);
      await WorkspaceService.deleteWorkspaceReport(reportToDelete._id);
      console.log("✅ Report deleted successfully");
      setIsConfirmDialogOpen(false);
      setReportToDelete(null);
      fetchWorkspaceReports();
    } catch (err) {
      console.error("❌ Failed to delete report:", err);
    } finally {
      setDeleting(false);
    }
  };

  // [NEW] Helper to calculate dates based on period string
  const calculateDateRange = (period) => {
    const toDate = new Date();
    let fromDate = new Date();

    if (period === "last_7_days") fromDate.setDate(toDate.getDate() - 7);
    else if (period === "last_14_days") fromDate.setDate(toDate.getDate() - 14);
    else if (period === "last_3_months") fromDate.setMonth(toDate.getMonth() - 3);
    else fromDate.setDate(toDate.getDate() - 30); // Default last_30_days

    return {
      fromDate: fromDate.toISOString(),
      toDate: toDate.toISOString()
    };
  };

  // [NEW] Handle Report Download
  const handleDownloadReport = async (report) => {
    // 1. Add to downloading set
    setDownloadingIds((prev) => new Set(prev).add(report._id));

    try {
      // 2. Prepare Profile Data with Date Range
      const period = report.config?.period || "last_30_days";
      const dateRange = calculateDateRange(period);

      const profileData = (report.config?.selectedProfiles || []).map(p => ({
        profileId: p.id,
        platform: p.platform,
        name: p.name,
        profilePictureUrl: p.profilePictureUrl,
        ...dateRange
      }));

      // 3. Call Service
      await ReportGenService.generateReport(
        profileData,
        false, // isPredictionEnabled
        "pdf", // outputType
        report.config?.visibleCharts || [],
        report.config?.chartConfigs || {},
        report.config?.branding_pack_id,
        report.config?.target_client
      );

    } catch (error) {
      console.error("Failed to download report:", error);
    } finally {
      // 4. Remove from downloading set
      setDownloadingIds((prev) => {
        const updated = new Set(prev);
        updated.delete(report._id);
        return updated;
      });
    }
  };

  // [NEW] Handle Report Email
  const handleSendReport = async (report) => {
    if (!report.recipient_emails || report.recipient_emails.length === 0) {
      openErrorDialog("Email Error", "No recipients defined for this report. Please add an email address in the configuration.");
      return;
    }

    setSendingIds((prev) => new Set(prev).add(report._id));

    try {
      const period = report.config?.period || "last_30_days";
      const dateRange = calculateDateRange(period);

      const profileData = (report.config?.selectedProfiles || []).map(p => ({
        profileId: p.id,
        platform: p.platform,
        name: p.name,
        profilePictureUrl: p.profilePictureUrl,
        ...dateRange
      }));

      await ReportGenService.emailReport(
        profileData,
        false,
        report.config?.visibleCharts || [],
        report.config?.chartConfigs || {},
        report.recipient_emails,
        report.config?.branding_pack_id,
        report.config?.target_client
      );
      // alert(`Report emailed to ${report.recipient_emails.join(", ")}`);
      openNotificationSB(
        "success",
        "check",
        "Email Sent",
        `Report emailed to ${report.recipient_emails.join(", ")}`
      );

    } catch (error) {
      console.error("Failed to email report:", error);
      // alert("Failed to send email.");
      openNotificationSB(
        "error",
        "warning",
        "Email Failed",
        "Failed to send email. Please try again."
      );
    } finally {
      setSendingIds((prev) => {
        const updated = new Set(prev);
        updated.delete(report._id);
        return updated;
      });
    }
  };

  // [NEW] Handle Snapshot Email
  const handleSendSnapshot = async (snapshot, run = null) => {
    const hasRecipients = snapshot.recipient_emails && snapshot.recipient_emails.length > 0;
    if (!hasRecipients) {
      openErrorDialog("Snapshot Error", "No recipients defined for this snapshot. Please add an email address in the configuration.");
      return;
    }

    setSendingIds((prev) => new Set(prev).add(snapshot._id));

    try {
      // Use run dates if provided, otherwise default to snapshot info
      const rangeStart = run?.range_start ? new Date(run.range_start) : (snapshot.rangeStart ? new Date(snapshot.rangeStart) : null);
      const rangeEnd = run?.range_end ? new Date(run.range_end) : (snapshot.rangeEnd ? new Date(snapshot.rangeEnd) : null);

      const snapshotInfo = {
        snapshotType: snapshot.snapshot_type,
        snapshotName: snapshot.snapshot_name,
        primary_profile: snapshot.primaryProfile,
        secondary_profiles: snapshot.secondaryProfiles,
        primary_entities: snapshot.primary_entities,
        secondary_entities: snapshot.secondary_entities,
        rangeStart,
        rangeEnd,
        branding_pack_id: snapshot.branding_pack_id || null, // [FIX] Include branding
        target_client: snapshot.target_client || null,       // [FIX] Include styling
      };

      await SnapshotService.emailSnapshot(snapshotInfo, snapshot.recipient_emails.map(e => e.email || e));

      openNotificationSB(
        "success",
        "check",
        "Success",
        `Snapshot "${snapshot.snapshot_name}" emailed successfully.`
      );
    } catch (err) {
      console.error("❌ Error sending snapshot email:", err);
      openNotificationSB(
        "error",
        "warning",
        "Error",
        `Failed to email snapshot: ${err.message || "Unknown error"}`
      );
    } finally {
      setSendingIds((prev) => {
        const next = new Set(prev);
        next.delete(snapshot._id);
        return next;
      });
    }
  };

  // [NEW] Handle completion of the demo flow
  const [closing, setClosing] = useState(false);

  const handleSnapshotComplete = () => {
    if (isLiveDemo) {
      setClosing(true);
      localStorage.setItem("social_studio_demo_completed", "true");

      // Delay navigation to allow "Slide Up" animation to complete
      setTimeout(() => {
        setDemoCompleted(true);
        setClosing(false);

        // [NEW] Mark this module as completed for the tour
        sessionStorage.setItem("demo_visited_studio", "true");
        window.dispatchEvent(new Event('demoVisitUpdated'));

        handleGoBack();
      }, 1000);
    } else {
      handleGoBack();
    }
  };

  const handleEditSnapshot = (snapshot) => {
    console.log("✏️ Editing Snapshot:", snapshot);

    setEditSnapshotData({
      snapshotId: snapshot._id,
      snapshotType: snapshot.snapshot_type,
      snapshotName: snapshot.snapshot_name,
      email: Array.isArray(snapshot.emails)
        ? snapshot.emails.join(", ")
        : snapshot.emails || "",
      scheduleMonthly:
        snapshot.schedule_enabled ||
        (snapshot.frequency && snapshot.frequency.toLowerCase() === "monthly"),
      primaryProfile:
        snapshot.primaryProfile && snapshot.primaryProfile.length > 0
          ? snapshot.primaryProfile[0]
          : null,
      secondaryProfiles: snapshot.secondaryProfiles || [],
    });

    setShowSnapshots(true);
  };

  // 🗑️ Delete Snapshot Handlers
  const handleDeleteClick = (snapshot) => {
    setSnapshotToDelete(snapshot);
    setIsConfirmDialogOpen(true);
  };

  const handleConfirmDelete = async () => {
    // 1. Handle Snapshot Deletion
    if (snapshotToDelete) {
      try {
        setDeleting(true);
        // Soft delete: update status to "inactive"
        await WorkspaceService.updateWorkspaceSnapshot(snapshotToDelete._id, { status: "inactive" });
        console.log("✅ Snapshot deactivated successfully");
        setIsConfirmDialogOpen(false);
        setSnapshotToDelete(null);
        fetchWorkspaceSnapshots();
      } catch (err) {
        console.error("❌ Failed to deactivate snapshot:", err);
      } finally {
        setDeleting(false);
      }
      return;
    }

    // 2. Handle Report Deletion
    if (reportToDelete) {
      handleConfirmReportDelete();
      return;
    }
  };

  // ───────────────────────────────
  // Table Columns and Rows
  // ───────────────────────────────
  const renderAvatars = (profiles) => {
    if (!Array.isArray(profiles)) return null;
    return (
      <MDBox display="flex" justifyContent="left" alignItems="left">
        <AvatarGroup max={4} sx={{ "& .MuiAvatar-root": { width: 28, height: 28 } }}>
          {profiles.map((profile, idx) => (
            <Tooltip key={idx} title={profile.name || "Profile"} arrow>
              <Avatar
                src={profile.profilePictureUrl || ""}
                alt={profile.name || "P"}
                sx={{ width: 28, height: 28 }}
              />
            </Tooltip>
          ))}
        </AvatarGroup>
      </MDBox>
    );
  };

  const columns = [
    {
      Header: (
        <MDBox py={1} px={2} pl={3} sx={{ minWidth: "250px" }}>
          <MDTypography variant="caption" sx={{ fontWeight: 800 }}>
            NAME
          </MDTypography>
        </MDBox>
      ),
      accessor: "snapshotName",
      align: "left",
    },
    {
      Header: (
        <MDBox py={1} px={2} pl={3}>
          <MDTypography variant="caption" sx={{ fontWeight: 800 }}>
            TYPE
          </MDTypography>
        </MDBox>
      ),
      accessor: "snapshotType",
      align: "left",
    },
    {
      Header: (
        <MDBox py={1} px={2} pl={3}>
          <MDTypography variant="caption" sx={{ fontWeight: 800 }}>
            PRIMARY
          </MDTypography>
        </MDBox>
      ),
      accessor: "primaryProfile",
      align: "left",
    },
    {
      Header: (
        <MDBox py={1} px={2} pl={3}>
          <MDTypography variant="caption" sx={{ fontWeight: 800 }}>
            SECONDARY
          </MDTypography>
        </MDBox>
      ),
      accessor: "secondaryProfiles",
      align: "left",
    },
    {
      Header: (
        <MDBox py={1} px={2} pl={3}>
          <MDTypography variant="caption" sx={{ fontWeight: 800 }}>
            RECIPIENT
          </MDTypography>
        </MDBox>
      ),
      accessor: "recipient",
      align: "left",
    },
    {
      Header: (
        <MDBox py={1} px={2} pl={3}>
          <MDTypography variant="caption" sx={{ fontWeight: 800 }}>
            NEXT RUN
          </MDTypography>
        </MDBox>
      ),
      accessor: "nextRunAt",
      align: "left",
    },
    {
      Header: (
        <MDBox py={1} px={2}>
          <MDTypography variant="caption" sx={{ fontWeight: 800 }}>
            ACTION
          </MDTypography>
        </MDBox>
      ),
      accessor: "action",
      align: "center",
    },
  ];

  const rows = workspaceSnapshots.map((snapshot) => {
    // Check if snapshot is active (ensure case-insensitive check if status exists)
    const isActive = snapshot.status && snapshot.status.toLowerCase() === "active";

    // Helper to render cell content (Opacity only, no Tooltip)
    const renderCell = (content) => {
      if (isActive) return content;
      return (
        <MDBox sx={{ opacity: 0.5, display: "inline-block", width: "100%" }}>
          {content}
        </MDBox>
      );
    };

    return {
      snapshotName: renderCell(snapshot.snapshot_name),
      snapshotType: renderCell(snapshot.snapshot_type || "—"),
      primaryProfile: renderCell(renderAvatars(snapshot.primaryProfile)),
      secondaryProfiles: renderCell(
        snapshot.secondaryProfiles && snapshot.secondaryProfiles.length > 0
          ? renderAvatars(snapshot.secondaryProfiles)
          : "—"
      ),
      recipient: renderCell(
        snapshot.recipient_emails && snapshot.recipient_emails.length > 0
          ? snapshot.recipient_emails.join(", ")
          : "—"
      ),
      nextRunAt: renderCell(
        snapshot.scheduleEnabled && snapshot.nextRunAt
          ? new Date(snapshot.nextRunAt).toLocaleDateString("en-GB")
          : "—"
      ),
      action: isActive ? (
        <MDBox display="flex" justifyContent="center" alignItems="center" gap={1}>
          <Tooltip title="Edit" arrow>
            <IconButton size="small" onClick={() => {
              if (!hasPerm("snapshots:manage")) {
                setRbacFeature("Editing Snapshots");
                setRbacRole(requiredRoles["snapshots:manage"] || "Manager");
                setShowRBAC(true);
                return;
              }
              handleEditSnapshot(snapshot);
            }}>
              <EditIcon fontSize="small" />
            </IconButton>
          </Tooltip>

          <Tooltip title="Download" arrow>
            <IconButton
              size="small"
              onClick={(event) => {
                if (!hasPerm("snapshots:view")) {
                  setRbacFeature("Downloading Snapshots");
                  setRbacRole(requiredRoles["snapshots:view"] || "Viewer");
                  setShowRBAC(true);
                  return;
                }

                if (snapshot.scheduleEnabled) {
                  handleMenuOpen(event, snapshot, "download");
                } else {
                  const prevMonth = subMonths(new Date(), 1);
                  const mockRun = {
                    range_start: format(startOfMonth(prevMonth), "yyyy-MM-dd"),
                    range_end: format(endOfMonth(prevMonth), "yyyy-MM-dd")
                  };
                  handleGenerateSnapshotFromRun(snapshot, mockRun);
                }
              }}
            >
              {downloadingIds.has(snapshot._id) ? (
                <CircularProgress size={18} thickness={4} color="accent" />
              ) : (
                <DownloadIcon fontSize="small" />
              )}
            </IconButton>
          </Tooltip>

          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl) && activeSnapshot?._id === snapshot._id}
            onClose={handleMenuClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            transformOrigin={{ vertical: "top", horizontal: "left" }}
          >
            {activeSnapshot?.snapshot_runs?.length > 0 ? (
              activeSnapshot.snapshot_runs
                .filter((run) => run.status === "success" || run.status === "completed" || run.url)
                .map((run, idx) => {
                  const label = formatMonthLabel(run.range_start);
                  return (
                    <MenuItem
                      key={idx}
                      onClick={() => {
                        if (menuIntent === "email") {
                          handleSendSnapshot(snapshot, run);
                        } else if (run.url) {
                          handleDownloadGCS(snapshot._id, idx);
                        } else {
                          handleGenerateSnapshotFromRun(snapshot, run);
                        }
                        handleMenuClose();
                      }}
                    >
                      {label}
                    </MenuItem>
                  );
                })
            ) : (
              <MenuItem disabled>No snapshot available</MenuItem>
            )}
          </Menu>

          <Tooltip title="Email Snapshot" arrow>
            <IconButton
              size="small"
              onClick={(event) => {
                if (!hasPerm("snapshots:manage")) {
                  setRbacFeature("Emailing Snapshots");
                  setRbacRole(requiredRoles["snapshots:manage"] || "Manager");
                  setShowRBAC(true);
                  return;
                }

                if (snapshot.scheduleEnabled) {
                  handleMenuOpen(event, snapshot, "email");
                } else {
                  const prevMonth = subMonths(new Date(), 1);
                  const mockRun = {
                    range_start: format(startOfMonth(prevMonth), "yyyy-MM-dd"),
                    range_end: format(endOfMonth(prevMonth), "yyyy-MM-dd")
                  };
                  handleSendSnapshot(snapshot, mockRun);
                }
              }}
              disabled={sendingIds.has(snapshot._id) || !(snapshot.recipient_emails && snapshot.recipient_emails.length > 0)}
            >
              {sendingIds.has(snapshot._id) ? (
                <CircularProgress size={18} thickness={4} color="accent" />
              ) : (
                <EmailIcon fontSize="small" />
              )}
            </IconButton>
          </Tooltip>

          <Tooltip title="Delete" arrow>
            <IconButton
              size="small"
              onClick={() => {
                if (!hasPerm("snapshots:manage")) {
                  setRbacFeature("Deleting Snapshots");
                  setRbacRole(requiredRoles["snapshots:manage"] || "Manager");
                  setShowRBAC(true);
                  return;
                }
                handleDeleteClick(snapshot);
              }}
            >
              <DeleteIcon fontSize="small" color="error" />
            </IconButton>
          </Tooltip>
        </MDBox>
      ) : (
        renderCell(
          <Tooltip title="Deleted Snapshot" placement="bottom" arrow>
            <MDTypography variant="caption" color="text">
              Deleted
            </MDTypography>
          </Tooltip>
        )
      ),
    };
  });

  // ───────────────────────────────
  // Reports Table Helper
  // ───────────────────────────────
  const calculateNextRun = (report) => {
    // [NEW] If not scheduled, show "Manual" or "—"
    if (report.scheduleEnabled === false) return "—";

    if (report.nextRunAt) return new Date(report.nextRunAt).toLocaleDateString("en-GB");

    // Fallback calculation based on createdAt + frequency
    // This is valid for newly created reports that haven't run yet
    const created = new Date(report.createdAt || new Date());
    const freq = report.frequency || "monthly";
    let nextDate = new Date(created);

    // Naive implementation: just add 1 period to created date
    // In a real app, you'd loop until > now, but for display this is okay for new reports
    switch (freq.toLowerCase()) {
      case "daily":
        nextDate = addDays(created, 1);
        break;
      case "weekly":
        nextDate = addWeeks(created, 1);
        break;
      case "monthly":
        nextDate = addMonths(created, 1);
        break;
      default:
        nextDate = addMonths(created, 1);
    }

    // If calculated date is in the past (e.g. old report), we might want to show "Overdue" or something,
    // but for now let's just show it.
    return format(nextDate, "dd/MM/yyyy");
  };

  const reportColumns = [
    {
      Header: (
        <MDBox py={1} px={2} pl={3} sx={{ minWidth: "250px" }}>
          <MDTypography variant="caption" sx={{ fontWeight: 800 }}>
            REPORT NAME
          </MDTypography>
        </MDBox>
      ),
      accessor: "reportName",
      align: "left",
    },
    {
      Header: (
        <MDBox py={1} px={2} pl={3}>
          <MDTypography variant="caption" sx={{ fontWeight: 800 }}>
            PROFILE
          </MDTypography>
        </MDBox>
      ),
      accessor: "profile",
      align: "left",
    },
    {
      Header: (
        <MDBox py={1} px={2} pl={3}>
          <MDTypography variant="caption" sx={{ fontWeight: 800 }}>
            RECIPIENT
          </MDTypography>
        </MDBox>
      ),
      accessor: "recipient",
      align: "left",
    },
    {
      Header: (
        <MDBox py={1} px={2} pl={3}>
          <MDTypography variant="caption" sx={{ fontWeight: 800 }}>
            FREQUENCY
          </MDTypography>
        </MDBox>
      ),
      accessor: "frequency",
      align: "left",
    },
    {
      Header: (
        <MDBox py={1} px={2} pl={3}>
          <MDTypography variant="caption" sx={{ fontWeight: 800 }}>
            PERIOD
          </MDTypography>
        </MDBox>
      ),
      accessor: "period",
      align: "left",
    },
    {
      Header: (
        <MDBox py={1} px={2} pl={3}>
          <MDTypography variant="caption" sx={{ fontWeight: 800 }}>
            NEXT RUN
          </MDTypography>
        </MDBox>
      ),
      accessor: "nextRun",
      align: "left",
    },
    {
      Header: (
        <MDBox py={1} px={2}>
          <MDTypography variant="caption" sx={{ fontWeight: 800 }}>
            ACTION
          </MDTypography>
        </MDBox>
      ),
      accessor: "action",
      align: "center",
    },
  ];

  const reportRows = workspaceReports.map((report) => ({
    reportName: (
      <MDBox sx={{ display: "inline-block", width: "100%" }}>
        {report.report_name}
      </MDBox>
    ),
    profile: renderAvatars(report.config?.selectedProfiles),
    recipient: (
      <MDBox sx={{ display: "inline-block", width: "100%", maxWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
        <Tooltip title={report.recipient_emails?.join(", ") || "No Recipient"} arrow>
          <span>{report.recipient_emails?.length > 0 ? report.recipient_emails.join(", ") : "—"}</span>
        </Tooltip>
      </MDBox>
    ),
    frequency: (
      <MDBox sx={{ textTransform: "capitalize" }}>
        {report.frequency || "Monthly"}
      </MDBox>
    ),
    period: (
      <MDBox sx={{ display: "inline-block", width: "100%", textTransform: "capitalize" }}>
        {report.config?.period ? report.config.period.replace(/_/g, " ") : "Last 30 days"}
      </MDBox>
    ),
    nextRun: (
      <MDBox sx={{ display: "inline-block", width: "100%" }}>
        {calculateNextRun(report)}
      </MDBox>
    ),
    action: (
      <MDBox display="flex" justifyContent="center" alignItems="center" gap={1}>
        <Tooltip title="Edit Report" arrow>
          <IconButton size="small" onClick={() => {
            if (!hasPerm("reports:manage")) {
              setRbacFeature("Editing Reports");
              setRbacRole(requiredRoles["reports:manage"] || "Analyst");
              setShowRBAC(true);
              return;
            }
            handleEditReport(report);
          }}>
            <EditIcon fontSize="small" />
          </IconButton>
        </Tooltip>

        {/* [NEW] Download Button */}
        <Tooltip title="Download Report" arrow>
          <IconButton size="small" onClick={() => {
            if (!hasPerm("reports:view")) {
              setRbacFeature("Downloading Reports");
              setRbacRole(requiredRoles["reports:view"] || "Viewer");
              setShowRBAC(true);
              return;
            }
            handleDownloadReport(report);
          }} disabled={downloadingIds.has(report._id)}>
            {downloadingIds.has(report._id) ? (
              <CircularProgress size={18} thickness={4} color="accent" />
            ) : (
              <DownloadIcon fontSize="small" />
            )}
          </IconButton>
        </Tooltip>

        {/* [NEW] Send Email Button */}
        <Tooltip title={(!report.recipient_emails || report.recipient_emails.length === 0) ? "No recipient emails" : "Email Report"} arrow>
          <span>
            <IconButton
              size="small"
              onClick={() => {
                if (!hasPerm("reports:manage")) {
                  setRbacFeature("Emailing Reports");
                  setRbacRole(requiredRoles["reports:manage"] || "Analyst");
                  setShowRBAC(true);
                  return;
                }
                handleSendReport(report);
              }}
              disabled={sendingIds.has(report._id) || !report.recipient_emails || report.recipient_emails.length === 0}
            >
              {sendingIds.has(report._id) ? (
                <CircularProgress size={18} thickness={4} color="accent" />
              ) : (
                <EmailIcon fontSize="small" />
              )}
            </IconButton>
          </span>
        </Tooltip>

        <Tooltip title="Delete Report" arrow>
          <IconButton size="small" onClick={() => {
            if (!hasPerm("reports:manage")) {
              setRbacFeature("Deleting Reports");
              setRbacRole(requiredRoles["reports:manage"] || "Analyst");
              setShowRBAC(true);
              return;
            }
            handleDeleteReportClick(report);
          }}>
            <DeleteIcon fontSize="small" color="error" />
          </IconButton>
        </Tooltip>
      </MDBox>
    ),
  }));

  const activeTableData = activeTab === 0
    ? { columns, rows }
    : { columns: reportColumns, rows: reportRows };

  // ───────────────────────────────
  // Render UI
  // ───────────────────────────────
  // [NEW] Dynamic Guidance Message State
  const [guidanceMessage, setGuidanceMessage] = useState("Select a Snapshot Type");

  // Reset guidance message when showing snapshot/report list
  useEffect(() => {
    if (showSnapshots || showReports) {
      setGuidanceMessage(showSnapshots ? "Select a Snapshot Type" : "Configure Report");
    }
  }, [showSnapshots, showReports]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SocialStudioGuidanceStep
        isLiveDemo={isLiveDemo && (!demoCompleted || closing)}
        message={(showSnapshots || showReports) ? guidanceMessage : undefined}
        closing={closing}
      />
      <MDBox pt={6} pb={3} sx={{ width: "100%", px: 0 }}>
        {!showSnapshots && !showReports ? (
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={1}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
              display="flex"
              flexDirection="row"
              alignItems="center"
              justifyContent="space-between"
            >
              <MDBox display="flex" alignItems="center">
                <MDTypography variant="h6" color="white">
                  Social Studio
                </MDTypography>
                <CustomTooltip title={tooltipContent} placement="bottom" arrow>
                  <IconButton sx={{ color: "white", p: 0, ml: 0.5 }}>
                    <InfoOutlinedIcon fontSize="small" />
                  </IconButton>
                </CustomTooltip>
              </MDBox>



              {/* Right Aligned Tabs with Sliding Animation */}
              <MDBox display="flex" justifyContent="flex-end" sx={{ width: "auto" }}>
                <AppBar position="static" sx={{ background: "transparent", boxShadow: "none" }}>
                  <Tabs
                    value={activeTab}
                    onChange={handleTabChange}
                    sx={{
                      backgroundColor: "rgba(255, 255, 255, 0.5)",
                      borderRadius: "12px",
                      minHeight: "unset",
                      padding: "4px",
                      "& .MuiTabs-indicator": {
                        backgroundColor: "#ffffff",
                        height: "100%",
                        borderRadius: "8px",
                        boxShadow: "0px 2px 10px 0px rgba(0,0,0,0.1)",
                        transition: "all 500ms ease"
                      },
                    }}
                  >
                    <Tab
                      icon={<PhotoCameraIcon fontSize="small" />}
                      iconPosition="start"
                      label="Snapshots"
                      sx={{
                        zIndex: 1,
                        minHeight: "35px",
                        borderRadius: "8px",
                        py: 0.5,
                        px: 2,
                        fontSize: "0.85rem",
                        textTransform: "none",
                        fontWeight: activeTab === 0 ? 700 : 400,
                        color: activeTab === 0 ? "#00A1A1 !important" : "#ffffff !important",
                        transition: "color 0.3s ease",
                        minWidth: "120px",
                        gap: 1,
                        "& .MuiSvgIcon-root": {
                          marginBottom: "0px !important",
                          color: activeTab === 0 ? "#00A1A1 !important" : "#ffffff !important",
                        }
                      }}
                    />
                    <Tab
                      icon={<AssessmentIcon fontSize="small" />}
                      iconPosition="start"
                      label="Reports"
                      sx={{
                        zIndex: 1,
                        minHeight: "35px",
                        borderRadius: "8px",
                        py: 0.5,
                        px: 2,
                        fontSize: "0.85rem",
                        textTransform: "none",
                        fontWeight: activeTab === 1 ? 700 : 400,
                        color: activeTab === 1 ? "#00A1A1 !important" : "#ffffff !important",
                        transition: "color 0.3s ease",
                        minWidth: "120px",
                        gap: 1,
                        "& .MuiSvgIcon-root": {
                          marginBottom: "0px !important",
                          color: activeTab === 1 ? "#00A1A1 !important" : "#ffffff !important",
                        }
                      }}
                    />
                  </Tabs>
                </AppBar>

              </MDBox>
            </MDBox>

            <Grid container justifyContent="center" mt={2} mb={0}>
              <Grid item>
                {activeTab === 0 ? (
                  <MDButton
                    variant="contained"
                    color="accent"
                    onClick={handleShowSnapshots}
                  >
                    Create Snapshot
                  </MDButton>
                ) : (
                  <MDButton
                    variant="contained"
                    color="accent"
                    onClick={handleCreateReport}
                  >
                    Create Report
                  </MDButton>
                )}
              </Grid>
            </Grid>

            {loading ? (
              <MDBox display="flex" justifyContent="center" alignItems="center" py={5}>
                <CircularProgress color="accent" />
              </MDBox>
            ) : error ? (
              <MDBox display="flex" justifyContent="center" mt={4}>
                <MDTypography color="error">{error}</MDTypography>
              </MDBox>
            ) : activeTableData.rows.length > 0 ? (
              <Grow in={true} timeout={600}>
                <div>
                  <DataTable
                    canSearch={true}
                    showTotalEntries={false}
                    isSorted={false}
                    noEndBorder
                    entriesPerPage={{ defaultValue: 5, entries: [5, 10, 15, 20, 50] }}
                    table={activeTableData}
                  />
                </div>
              </Grow>
            ) : (
              <MDBox p={3}>
                <MDTypography variant="subtitle1" color="text" align="center">
                  {isLiveDemo
                    ? ""
                    : activeTab === 0 ? "No snapshots found." : "No reports found."}
                </MDTypography>
              </MDBox>
            )}
          </Card>
        ) : showSnapshots ? (
          <SocialSnapshot
            goBack={handleGoBack}
            onComplete={handleSnapshotComplete}
            editSnapshotData={editSnapshotData}
            entitlements={entitlements}
            setGuidanceMessage={setGuidanceMessage}
            showGuidance={!demoCompleted}
            isLiveDemo={isLiveDemo}
          />
        ) : (
          <SocialReport
            goBack={handleReportGoBack}
            onComplete={handleReportGoBack}
            editReportData={editReportData}
            showNotification={openNotificationSB}
            entitlements={entitlements}
          />
        )}
      </MDBox>

      {/* 🧩 Confirm Delete Dialog */}
      <Dialog open={isConfirmDialogOpen} onClose={() => setIsConfirmDialogOpen(false)}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete {snapshotToDelete ? "snapshot" : "report"}{" "}
            <strong>
              {snapshotToDelete?.snapshot_name || reportToDelete?.report_name}
            </strong>
            ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsConfirmDialogOpen(false)} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} color="error" disabled={deleting}>
            {deleting ? "Deleting..." : "Confirm Delete"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* 🧩 Professional Error/Alert Dialog */}
      <Dialog
        open={isErrorDialogOpen}
        onClose={() => setIsErrorDialogOpen(false)}
        PaperProps={{
          style: { borderRadius: "12px", minWidth: "400px" }
        }}
      >
        <DialogTitle sx={{ color: "#344767" }}>{errorDialogTitle}</DialogTitle>
        <DialogContent>
          <DialogContentText variant="body2" sx={{ color: "#67748e", mt: 1 }}>
            {errorDialogMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <MDButton
            variant="gradient"
            color="info"
            onClick={() => setIsErrorDialogOpen(false)}
            sx={{ minWidth: "100px" }}
          >
            OK
          </MDButton>
        </DialogActions>
      </Dialog>

      <Footer />

      {/* [NEW] Render Snackbar */}
      <MDSnackbar
        color={notificationSB.color}
        icon={notificationSB.icon}
        title={notificationSB.title}
        content={notificationSB.content}
        dateTime="Just now"
        open={notificationSB.open}
        onClose={closeNotificationSB}
        close={closeNotificationSB}
        bgWhite
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        autoHideDuration={null}
      />

      {/* [NEW] Live Demo Restriction Popup */}
      <LiveDemoRestriction
        open={showLiveDemoPopup}
        onClose={() => setShowLiveDemoPopup(false)}
        featureName="Creating Report"
        helpText="Try creating a Snapshot instead"
      />

      <UpgradePopup
        open={showReportUpgrade}
        onClose={() => setShowReportUpgrade(false)}
        type={reportUpgradeType}
        featureName="Report"
        planRequired={entitlements?.requiredPlans?.["Report"] || "Higher Plan"}
        currentPlan={entitlements?.plan}
        usageLimit={entitlements?.limits?.reports}
        unit="reports"
      />

      {/* [NEW] RBAC Restriction Popup */}
      <UpgradePopup
        open={showRBAC}
        onClose={() => setShowRBAC(false)}
        type="rbac"
        featureName={rbacFeature}
        roleRequired={rbacRole}
      />
    </DashboardLayout >
  );
}

export default SocialStudio;
